import type { SessionRequestAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import CourseQ from './CourseQ'
import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import TopicQ from './TopicQ'
import UserQ from './UserQ'

const SessionRequestQ = {
  ...makeQueryModelV2<SessionRequestAttributes>('session_request')([
    'id',
    'user_id',
    'topic_id',
    'details',
    'created_at',
    'updated_at',
    'status',
    'activity_log',
    'priority',
    'deleted_at',
  ]),

  where: (
    {
      id = null,
      userId = null,
      topicId = null,
      paranoid = true,
      includeTopic = false,
      includeUser = false,
      includeCourse = false,
      groupBy = null,
      order = null,
    }: {
      id?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      topicId?: number | null | SQLFragment<number>
      paranoid?: boolean
      includeTopic?: boolean
      includeUser?: boolean
      includeCourse?: boolean
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SessionRequestAttributes> => SQL`
        FROM ${SessionRequestQ}
        ${
          includeUser ? SQL`INNER JOIN ${UserQ} ON ${UserQ.id} = ${SessionRequestQ.user_id}` : SQL``
        }
        ${
          includeTopic || includeCourse
            ? SQL`INNER JOIN ${TopicQ} ON ${TopicQ.id} = ${SessionRequestQ.topic_id}`
            : SQL``
        }
        ${includeCourse ? SQL`INNER JOIN ${CourseQ} ON ${CourseQ.id} = ${TopicQ.course_id}` : SQL``}
        WHERE
            ${id != null ? SQL`${SessionRequestQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${SessionRequestQ.user_id} = ${userId} AND` : SQL``}
            ${topicId != null ? SQL`${SessionRequestQ.topic_id} = ${topicId} AND` : SQL``}
            ${paranoid ? SQL`${SessionRequestQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default SessionRequestQ
